import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiCheckCircle } = FiIcons;

const Curriculum = () => {
  const modules = [
    {
      id: "01",
      title: "História da Família e Conjugalidade",
      desc: "As famílias contemporâneas vivem novos modelos de funcionamento, e a transição da conjugalidade para a parentalidade impacta diretamente a forma de educar e cuidar da criança. Compreender essas transformações contribui para uma adaptação mais saudável do casal, redução de conflitos e desenvolvimento emocional equilibrado da criança.",
      img: "https://images.unsplash.com/photo-1511895426328-dc8714191300?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "02",
      title: "Expectativas com o Nascimento de uma Criança",
      desc: "A chegada de um filho desperta expectativas conscientes e inconscientes nos pais. Refletir sobre essas expectativas ajuda a educar com compreensão, estabelecer limites consistentes e respeitar a individualidade da criança, promovendo um desenvolvimento saudável.",
      img: "https://images.unsplash.com/photo-1519689680058-324335c77eba?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "03",
      title: "Terapia Cognitivo-Comportamental (TCC)",
      desc: "A TCC parte do princípio de que não são as situações que geram sofrimento, mas a forma como as interpretamos. Ao compreender essa relação entre pensamentos, emoções e comportamentos, ampliamos nossa consciência emocional e desenvolvemos respostas mais equilibradas.",
      img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "04",
      title: "Psicoeducação das Emoções",
      desc: "A psicoeducação das emoções permite que a criança reconheça, nomeie e compreenda o que sente. Ao aprender que todas as emoções têm uma função e que podem ser expressas de forma saudável, a criança desenvolve maior autorregulação emocional e segurança interna.",
      img: "https://images.unsplash.com/photo-1475483768296-6163e08872a1?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "05",
      title: "Temperamento, Personalidade e Caráter",
      desc: "Personalidade, temperamento e caráter são dimensões fundamentais do desenvolvimento humano. O temperamento refere-se às características inatas, à forma como a criança reage ao mundo desde os primeiros anos de vida. A personalidade se constrói ao longo do tempo.",
      img: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "06",
      title: "Teoria do Apego",
      desc: "A Teoria do Apego explica como os vínculos afetivos estabelecidos na infância influenciam a forma como a criança se percebe, se relaciona e regula suas emoções. Um apego seguro se constrói a partir de relações consistentes e emocionalmente disponíveis.",
      img: "https://images.unsplash.com/photo-1516627145497-ae6968895b74?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "07",
      title: "Estilos Parentais",
      desc: "Os estilos parentais refletem a forma como os pais exercem cuidado, autoridade e afeto na educação dos filhos. Cada estilo influencia diretamente o desenvolvimento emocional, comportamental e social da criança. Ao compreender os impactos, os pais ampliam sua consciência.",
      img: "https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "08",
      title: "Necessidades Emocionais Básicas",
      desc: "Segundo Jeffrey Young, todos temos cinco necessidades emocionais básicas: aceitação, autonomia, limites realistas, respeito aos desejos e expressão emocional. Atender essas necessidades na infância favorece a segurança e o equilíbrio emocional.",
      img: "https://images.unsplash.com/photo-1444840535719-195841cb6e2b?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "09",
      title: "Necessidades Básicas",
      desc: "As necessidades básicas são essenciais para que a criança se desenvolva de forma saudável. Garantir momentos de ócio, respeitar a rotina, estimular o brincar, cuidar da alimentação e do sono contribui para seu bem-estar físico e cognitivo.",
      img: "https://images.unsplash.com/photo-1464998857633-50e59fbf2fe6?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "10",
      title: "Inteligência",
      desc: "Inteligência é a capacidade de aprender e resolver problemas. Como ressalta Içami Tiba, “não basta ser inteligente, tem que ser ético”. O verdadeiro desenvolvimento intelectual não está apenas no acúmulo de conhecimentos, mas na capacidade de agir com responsabilidade.",
      img: "https://images.unsplash.com/photo-1509062522246-3755977927d7?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "11",
      title: "Regras e Limites com Afeto",
      desc: "Estabelecer regras e limites é fundamental para que a criança se sinta segura. Quando aplicados com afeto e clareza, a criança entende o que é esperado dela sem medo. Limites ensinam autocontrole e responsabilidade, fortalecendo vínculos saudáveis.",
      img: "https://images.unsplash.com/photo-1476703993599-0035a21b17a9?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "12",
      title: "Como Incentivar Comportamentos Adequados",
      desc: "Incentivar comportamentos adequados vai além de recompensar boas ações. Trata-se de reconhecer esforços e reforçar atitudes positivas em um ambiente seguro. Estratégias conscientes fortalecem a autoestima e autonomia dos filhos.",
      img: "https://images.unsplash.com/photo-1543269865-cbf427effbad?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "13",
      title: "Crianças e Telas",
      desc: "O uso de telas é inevitável, mas é essencial equilibrar tempo e conteúdo. Orientar e propor alternativas saudáveis ajuda a proteger o desenvolvimento cognitivo e social da criança, promovendo hábitos digitais conscientes desde cedo.",
      img: "https://images.unsplash.com/photo-1588702547919-26089e690ecc?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "14",
      title: "Álcool, Drogas, Sexualidade e Identidade de Gênero",
      desc: "Conversar sobre temas complexos é essencial para proteger os filhos. Abordar esses assuntos com respeito e diálogo aberto fortalece vínculos e promove escolhas conscientes, ajudando a criança a se sentir segura e acolhida.",
      img: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?q=80&w=800&auto=format&fit=crop"
    },
    {
      id: "15",
      title: "Estratégias Práticas",
      desc: "Este módulo oferece ferramentas e práticas para aplicar os conceitos aprendidos. Pais podem usar estratégias conscientes, afetivas e consistentes para promover desenvolvimento emocional, autonomia e relações familiares saudáveis.",
      img: "https://images.unsplash.com/photo-1490730141103-6cac27aaab94?q=80&w=800&auto=format&fit=crop"
    }
  ];

  return (
    <section id="curriculum" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-black text-[#2c3a50] mb-4 uppercase tracking-tight">O que você vai aprender</h2>
          <p className="text-gray-600 font-medium max-w-3xl mx-auto">
            Uma trilha completa dividida em 15 módulos práticos para transformar a atmosfera da sua casa com base científica.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {modules.map((module, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
              viewport={{ once: true }}
              className="bg-white rounded-[2.5rem] overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group flex flex-col md:flex-row"
            >
              <div className="w-full md:w-1/3 h-48 md:h-auto relative overflow-hidden bg-gray-200 shrink-0">
                <img 
                  src={module.img} 
                  alt={module.title} 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 bg-[#2c3a50] text-white px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider">
                  Módulo {module.id}
                </div>
              </div>
              <div className="p-8 flex flex-col justify-center">
                <h3 className="text-xl font-extrabold text-[#2c3a50] leading-tight mb-4 uppercase tracking-tighter">
                  {module.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed text-justify">
                  {module.desc}
                </p>
                <div className="mt-6 flex items-center text-[#c5a059] text-[10px] font-bold uppercase tracking-[0.2em] gap-2">
                  <SafeIcon icon={FiCheckCircle} className="w-4 h-4" />
                  <span>CONTEÚDO COMPLETO DISPONÍVEL</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Curriculum;